module.exports = __webpack_public_path__ + "static/media/brand-icons.e8c322de.woff2";